$('.discountslick').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 6000,
  dots: false,
  lazyLoad: 'ondemand',
  slideEndAnimation: true,
});

$('.discountslick2').slick({
  slidesToShow: 2,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 6000,
  dots: false,
  slideEndAnimation: true,
  lazyLoad: 'ondemand',
  slideEndAnimation: true,
  responsive: [
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '5px',
        slidesToShow: 1
      }
    }
  ]
});

$('.productinsights').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: false,
  dots: false,
  slideEndAnimation: true,
  infinite: false,
  responsive: [
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: true,
        arrows: true,
        centerPadding: '5px',
        slidesToShow: 1
      }
    }
  ]
});


/*$('#myBtn').click(function(){ 
  alert("gg");
  $('.product-details-content-new').css('height', 'auto'); 
})*/

function myFunction() {
  var dots = document.getElementById("dots");
  var moreText = document.getElementById("more");
  var btnText = document.getElementById("details_more");

  if (moreText.style.display === "none") {
    alert("in if");
    dots.style.display = "inline";
    btnText.innerHTML = "Read more"; 
    moreText.style.display = "none";
  } else {
    dots.style.display = "none";
    btnText.innerHTML = "Read less"; 
    moreText.style.display = "inline";
  }
}




$('.testimonialslide').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  dots: false,
  autoplaySpeed: 6000,
  slideEndAnimation: true,
  infinite: true,
  responsive: [
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: true,
        arrows: true,
        centerPadding: '5px',
        slidesToShow: 1
      }
    }
  ]
});



